import { createFileRoute } from '@tanstack/react-router';
import React from 'react';
import Head from 'next/head';
import DashboardLayout from '@/components/layouts/dashboard';
import GridMaps from '@/featured/dashboard/grid-maps';

export default function GridMapsPage() {
  return (
    <DashboardLayout>
      <Head>
        <title>Grid Maps · Missi</title>
      </Head>
      <div className="w-full">
        <GridMaps />
      </div>
    </DashboardLayout>
  );
}

export const Route = createFileRoute('/_authenticated/grid-maps')({
  component: GridMapsPage,
});
